import request from '@/utils/request'
import https from '@/utils/https.js'
export function findResult(key_words) {
    return request({
        url: '/web/index/get_find_result',
        method: 'post',
        data: {
            key_words: key_words
        }
    })
}
export function schoolRank(rank_type) {
    return https({
        url: '/api/school_rank/index',
        method: 'post',
        data: {
            rank_type: rank_type
        }
    })
}
export function schoolNews() {
    return https({
        url: '/api/news/index',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}
export function getHistoryData() {
    return request({
        url: '/web/Sim/getHistoryData',
        method: 'post',
        data: {
            area: localStorage.getItem('area')
        }
    })
}
export function recommendSchool(scl_nature_type) {
    return https({
        url: '/api/school_rank/recommendSchool',
        method: 'post',
        data: {
            scl_nature_type: scl_nature_type,
            area: localStorage.getItem('area')
        }
    })
}
export function getRecomendVideo() {
    return https({
        url: '/api/video/getRecomendVideo',
        method: 'post',
        data: {
        }
    })
}
export function getEvaluationTimes() {
    return request({
        url: '/web/psytest/lst',
        method: 'post',
        data: {
        }
    })
}
export function saveUserName(data) {
    return request({
        url: '/web/other/saveUserName',
        method: 'post',
        data: {
            user_name: data.user_name
        }
    })
}

export function getWebsite(domain) {
    return request({
        url: '/web/index',
        method: 'post',
        data: {
            domain: domain
        }
    })
}

export function getArea(year) {
    return https({
        url: '/api/area',
        method: 'post',
        data: {
            year: year
        }
    })
}

export function getBatch(form) {
    return https({
        url: '/api/batch',
        method: 'post',
        data: {
            area: form.area,
            year: form.year,
            scl_id: form.scl_id || '',
        }
    })
}


// //获取省份列表
// export function getProvince(){
//     return request({
//         url: '/web/region/provinces',
//         method: 'post',
//         data: {}
//     })
// }
// //获取城市列表
// export function getCity(province_id){
//     return request({
//         url: '/web/region/cities',
//         method: 'post',
//         data: {
//             province_id: province_id
//         }
//     })
// }
// //获取区县列表
// export function getAreas(province_id){
//     return request({
//         url: '/web/region/areas',
//         method: 'post',
//         data: {
//             city_id: province_id
//         }
//     })
// }
//获取学校列表
export function getSchools(keyword){
    return request({
        url: '/web/other/get_school_by_area',
        method: 'post',
        data: {
            keyword:keyword
        }
    })
}


